import { Repository } from "typeorm";
import { InjectRepository } from "@nestjs/typeorm";
import { ItemAttributesEntity } from "./entittes/item-attributes.entity";
import { CommonResponseModel } from "@project-management-system/shared-models";
import { ItemAttributeDto } from "./dto/item-attribute-dto";


export class ItemAttributeService {

    constructor(
        @InjectRepository(ItemAttributesEntity)
        private repository: Repository<ItemAttributesEntity>
    ) { }



    async createItemAttribute(createDto: ItemAttributeDto): Promise<CommonResponseModel> {
    
        try {
            let entity: ItemAttributesEntity;
            if (createDto.id) {
                const existingRecord = await this.repository.findOne({where:{id:createDto.id}});
                if (!existingRecord) {
                    return new CommonResponseModel(false, 404, 'Record not found');
                }
                existingRecord.attribute = createDto.attribute;
                existingRecord.attributeValue = createDto.attributeValue;
                existingRecord.style = createDto.style;
                existingRecord.itemId = createDto.itemId;
                existingRecord.imCode = createDto.imCode;
    
                entity = await this.repository.save(existingRecord);
            } else {
                entity = new ItemAttributesEntity();
                entity.attribute = createDto.attribute;
                entity.attributeValue = createDto.attributeValue;
                entity.itemId = createDto.itemId;
                entity.style = createDto.style;
                entity.imCode = createDto.imCode;
                entity = await this.repository.save(entity);
            }
            return new CommonResponseModel(true, 1111, 'Data Saved Successfully', entity);
        } catch (err) {
            return new CommonResponseModel(false, 0, err);
        }
    }
    
    
    
    async getItemAttribute():Promise<CommonResponseModel>{
        const query =`select ita.id as id ,ita.style as style,ita.attribute as attribute ,ita.attribute_value as attributeValue,it.item_id as itemId,it.item as item,ita.im_code as imCode FROM item_attributes ita
        left join items it on ita.item_id = it.item_id `
        const data = await this.repository.query(query)
        if (data.length) {
            return new CommonResponseModel(true, 1, 'data retrived', data)
        } else {
            return new CommonResponseModel(false, 0, 'error')
        }
    }


    async getStyles():Promise<CommonResponseModel>{
        const query =` SELECT id,style AS style FROM styles`
        const data = await this.repository.query(query)
        if (data.length) {
            return new CommonResponseModel(true, 1, 'data retrived', data)
        } else {
            return new CommonResponseModel(false, 0, 'error')
        }
    }


    async getAllItems(): Promise<CommonResponseModel> {
        const query = `SELECT item_id as itemId,item as item FROM items`
        const data = await this.repository.query(query)
        if (data) {
            return new CommonResponseModel(true, 1, 'Data Retrived', data)
        } else {
            return new CommonResponseModel(false, 0, 'No Data', [])
    
        }
    }

    async getImCode():Promise<CommonResponseModel>{
        const query =`SELECT id,im_code as imCode FROM bom`
        const data = await this.repository.query(query)
        if (data.length) {
            return new CommonResponseModel(true, 1, 'data retrived', data)
        } else {
            return new CommonResponseModel(false, 0, 'error')
        }
    }

            
}